/**
 * /app/$tenantSlug/settings/checklists/offboarding — Settings › People ›
 * Checklists, Offboarding tab (migration 170; spec
 * docs/superpowers/specs/2026-11-02-checklists-preboarding.md §3, §5).
 */

import { createFileRoute } from "@tanstack/react-router";
import { ChecklistsRoutePage } from "@/components/settings/checklists/checklists-route-page";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/settings/checklists/offboarding")({
  component: () => <ChecklistsRoutePage stage="offboarding" />,
});
